export interface TicketAccess {
  exerciseIds: string;
  exerciseName: string;
  startDate: number;
  seatIds: string;
  seatName: string;
  rowName: string;
}

export const setTicketAccess = (exerciseIds: string, seatIds: string): TicketAccess => {
  return {
    exerciseIds,
    seatIds,
  } as TicketAccess;
};

export const setTicketExercise = (exerciseTicketAcces: TicketAccess): TicketAccess => {
  return {
    exerciseIds: exerciseTicketAcces.exerciseIds,
    exerciseName: exerciseTicketAcces.exerciseName,
    startDate: exerciseTicketAcces.startDate,
  } as TicketAccess;
};

export const setTicketAccessFromExercise = (ids:number, name:string, startTime: number): TicketAccess => {
  return {
    exerciseIds: `${ids}`,
    exerciseName: name,
    startDate: startTime,
  } as TicketAccess;
}

export const setTicketAccessWithSelectedSeats = (
  exerciseIds: string,
  seatIds: string,
  seatName: string,
  rowName: string
): TicketAccess => {
  return {
    exerciseIds,
    seatIds,
    seatName,
    rowName
  } as TicketAccess;
};
